import { createAction, props } from "@ngrx/store";
import { IFuturesNewChallengeOptionConfiguration } from "../../futures/classes/FuturesNewChallengeOptionConfiguration";

export const setFuturesNewChallenge = createAction(
  "[Futures Challenges V2] Set New Challenge",
  props<{ selectedChallenge: IFuturesNewChallengeOptionConfiguration }>(),
);
